import { render, staticRenderFns } from "./CardManage.vue?vue&type=template&id=13df5ac2&scoped=true&"
import script from "./CardManage.vue?vue&type=script&lang=js&"
export * from "./CardManage.vue?vue&type=script&lang=js&"
import style0 from "./CardManage.vue?vue&type=style&index=0&id=13df5ac2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13df5ac2",
  null
  
)

export default component.exports